import React from 'react'
import StaticPageForm from './StaticPageForm'

function EditStaticPage() {
    return (
        <div><StaticPageForm type="EDIT" /></div>
    )
}

export default EditStaticPage